/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import { DashedLine2, LinkArr, SQRFSvg, StationSvg } from "../../../common/svg/AllSvg";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import useAxios from "../../../../shared/hooks/use-axios";
import { url } from "../../../../shared/utils/url";
import Img1 from "../../../../assets/images/property1.png";
import Img2 from "../../../../assets/images/property2.png";
import Img3 from "../../../../assets/images/property3.png";
import Img4 from "../../../../assets/images/property4.png";

const Properties = () => {
    const lang: string = useSelector((state: any) => state.ui.lang);
    const { t } = useTranslation('common');
    const [data, setData] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate();
    const params = useParams();
    const loaderData: any[] = [1, 2, 3, 4]

    const getProperties = async () => {
        try {
            setLoading(true)
            const payload = {
                property_type: undefined,
                status: undefined,
                location: undefined,
                search_text: undefined
            };

            const res: any = await useAxios.post(
                `/${!!lang ? lang : "en"}${url.search_property}`,
                payload
            );

            if (res && res.status === 200) {
                setData(res?.data?.results)
                setLoading(false)
            }
        } catch (error: any) {
            setLoading(false)
            console.error("error while fetching properties", error);
        }
    }

    useEffect(() => {
        !!lang && getProperties();
    }, [lang])

    return (
        <div className="mt-[30px] lg:mt-[70px] xlx:mt-[80px] w-full bg-[#E5FFFD] py-[30px] lg:py-[58px]">
            <div className="container w-full flex flex-col">
                <div className="flex flex-col">
                    {lang === 'en' ? <h1 className="text-primaryText font-bold"><span className="text-secDarkRed">Unl<span className="text-danger">oc</span>k</span> New Growth Opportunities</h1> : lang === 'hi' ? <h1 className="text-primaryText font-bold"><span className="text-secDarkRed">न<span className="text-danger">ए</span></span> विकास अवसरों को अनलॉक करें</h1> : <h1 className="text-primaryText font-bold"><span className="text-secDarkRed">न<span className="text-danger">वी</span>न</span> विकास संधींना उघडा</h1>}
                    <h6 className="text-blackDull font-medium max-w-[795px]">{t("corporate.content_pages.properties.desc")}</h6>
                </div>

                <div className="w-full overflow-hidden min-h-[2px] my-[20px]">
                    <DashedLine2 />
                </div>

                <div className="flex flex-col w-full">
                    <div className="w-full grid grid-cols-1 xsm:grid-cols-2 mms:grid-cols-3 xl:grid-cols-4 gap-[15px] md:gap-[20px] xlx:gap-[25px]">
                        {loading ?
                            <>
                                {Array.isArray(loaderData) && loaderData.map((item: any, index: number) => (
                                    <div className="w-full animate-pulse rounded-[15px] bg-[#FCFCFC] border border-[#ECF0F8] dark:border-[#454545]" key={index}>
                                        <div className="rounded-t-[15px] w-full h-[190px] md:h-[245px] bg-gray-200 dark:bg-gray-700"></div>

                                        <div className='px-[20px] xlx:px-[22px] py-[16px] xlx:py-[18px] flex flex-col'>
                                            <div className="w-[80%] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700 mb-[8px]"></div>
                                            <div className="w-[80%] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700 mb-[6px]"></div>
                                            <div className="w-[60%] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                        </div>
                                    </div>
                                ))}
                            </>
                            : <>
                                {Array.isArray(data) && data?.slice(0, 4).map((item: any, index: number) => (
                                    <div className="flex flex-col w-full rounded-[15px] bg-[#FCFCFC] border border-[#ECF0F8] relative" key={index}>
                                        <div className="absolute top-0 left-0 p-[16px] flex items-start justify-start">
                                            <div className={`border border-[#C8C8C8] dark:border-[#454545] bg-opacity-[0.8] flex items-center justify-center px-[11px] h-[22px] rounded-[10px] text-white text-xs font-bold uppercase whitespace-nowrap ${item?.lease_status === 'Available for Lease' ? "bg-[#10B85D]" : "bg-[#B81013]"}`}>{item?.lease_status === 'Available for Lease' ? "Vacant" : "Occupied"}</div>
                                        </div>
                                        <img src={!!item?.blog_image?.file ? item?.blog_image?.file : (index + 1) % 4 === 1 ? Img1 : (index + 1) % 4 === 2 ? Img2 : (index + 1) % 4 === 3 ? Img3 : (index + 1) % 4 === 4 ? Img4 : Img4} alt={item?.name} className="rounded-t-[15px] w-full h-[195px]" />
                                        <div className="px-[20px] xlx:px-[22px] py-[16px] xlx:py-[18px] flex flex-col">
                                            <h4 className="text-primaryText font-bold mb-[8px]">{item?.name}</h4>
                                            <div className="flex gap-[8px] mb-[6px]"><StationSvg className="fill-blackDull min-w-[16px] mt-[1px]s" /> <h6 className="text-blackDull font-semibold">{item?.location} {t("corporate.content_pages.properties.metro_station")}</h6></div>
                                            <div className="flex items-center gap-[8px]"><SQRFSvg /> <h6 className="text-blackDull font-semibold">{item?.area} {t("corporate.content_pages.properties.sqft")}</h6></div>
                                        </div>
                                    </div>
                                ))}
                            </>}
                    </div>

                    {!loading && <div className="w-full flex items-center justify-end pt-[30px] pr-[10px]">
                        <button className="text-primaryText font-bold text-lg flex items-center gap-[8px] focus:underline hover:underline" onClick={() => !!params?.lang ? navigate(`/${params?.lang}/properties`) : navigate(`/properties`)}>
                            {t("corporate.banner.view_all")}
                            <div className="pb-[1px]">
                                <LinkArr className="fill-primaryText min-w-[12px] w-[12px] h-[12px]" />
                            </div>
                        </button>
                    </div>}

                </div>

            </div>
        </div >
    );
};

export default Properties;